// Imports ------------------------------------------------------------------->

import {Component, attr} from "../Component";
import {element} from "../CustomElement";
import {i18n} from "../../i18n/I18n";

import {inject} from "../../services/di";
import {LocationService} from "../../services/LocationService";
import {AnalyticsService} from "../../services/AnalyticsService";
import {UserAgentService} from "../../services/UserAgentService";
import {ConfigService} from "../../services/ConfigService";

// Private Definitions ------------------------------------------------------->

// Public Definitions -------------------------------------------------------->

interface MobileInstallProperties extends JSX.HTMLProps {
	feature?: string;
	noFooterBg?: string;
}

@element("flipp-mobile-install")
export class MobileInstall extends Component<MobileInstallProperties, {}> {
	@attr feature: string;
	@attr noFooterBg: string;
	@inject userAgent: UserAgentService;
	@inject location: LocationService;
	@inject analytics: AnalyticsService;
	@inject config: ConfigService;

	render() {
		if (this.config.shouldDisableMobileBanners()) {
			return null;
		}
		// FIXME [FW-211] Support clippings interstital
		const feature = "coupons";

		const device = this.userAgent.android ? "android" : "ios";
		const lang = this.location.locale.split("-")[0];
		const country = (lang === "fr") ? "fr" :
				/[a-zA-Z]/.test(this.location.postalCode) ? "ca" : "us";
		const imageUrl = `https://f.wishabi.net/creative/Distribution/images/` + (
				feature === "coupons" ?
					`${device}-${country}-coupons.png`
				:
					`${device}-clippings.png`
		);
		const appStoreBadgeUrl = `https://f.wishabi.net/creative/Distribution/images/` +
				`${device}-appstore-${lang}` + (this.userAgent.android ? ".png" : ".png");

		const footerClass = this.noFooterBg === "false" ? "disabled-bg" : "";

		return <div class={`content ${device}`} flex-vertical>
				<div class="feature">
					<h1>{i18n("mobile_install_headline")}</h1>
					<h2>{i18n("mobile_install_subline")}</h2>
					<hr />
					<p>
						{i18n(`mobile_install_${feature}`)}
					</p>
					<img class="app-tease" src={imageUrl} alt="" />
				</div>
				<footer class={footerClass}>
					<a href="https://flipp.app.link/hZ35AqABBab" onClick={this.handleInstallClick_}>
						<img alt="Install Flipp" src={appStoreBadgeUrl} />
					</a>
				</footer>
			</div>;
	}

	private handleInstallClick_ = (e: Event) => {
		this.analytics.trackMobileInstall(this.userAgent.android ? "android" : "ios");
	}
}
